//External
import LoginModal from "components/modals/loginModal";
import SuccessPopup from "components/modals/success-popup";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getDynamicPageData,
} from "store/actions";

//Internal
// Import directly, not from the components/cards barrel - that barrel also
// re-exports the Stripe payment cards, which call loadStripe(STRIPE_KEY) at
// module scope. Any page pulling CarCard in through the barrel eagerly
// triggers a Stripe.js network request too, even though it has nothing to do
// with payments - if that request fails (offline, ad blocker, etc.) it
// surfaces as an unrelated "Failed to load Stripe.js" runtime error.
import CarCard from "components/cards/car-card";
import { getVehicalDetailData, setShowOtpBlock } from "store/actions";
import { addUserFavorite } from "store/actions/userfavorite";
import {
  ALREADY_SAVED_WISHLIST,
  callVehicleApiForFilterOption,
  get_cookie,
  REMOVED_WISHLIST,
  SAVED_WISHLIST,
} from "utils";

/*******************
@Purpose : Used for the specials
@Parameter : {data}
@Author : INIC
******************/
function TheSpecials({ data, flag, whichPage, slug3, onVehicleClick }) {
  const dispatch = useDispatch();
  const user = useSelector((state) => state?.user);
  const is_mobile_app = get_cookie("is_mobile_app");
  const myVehicleSlug = "?screen_type=car_details&brand_title=";
  let slugPrefix = "";
  const r = get_cookie("redirectUrl");
  const dUrl = "/ca/los-angeles";
  if (r) {
    if (r === "/") {
      slugPrefix = dUrl;
    } else {
      slugPrefix = r;
    }
  } else {
    slugPrefix = dUrl;
  }

  const [vId, setVId] = useState("");
  const [vSlug, setVSlug] = useState("");
  const [clickOnFavorite, setClickOnFavorite] = useState(0);
  const [addOnClass, setAddOnClass] = useState("hide");
  const [favUnFavMessage, setFavUnFavMessage] = useState("");
  const [isSaved, setIsSaved] = useState(false);

  // Login modal property
  const [show, setShow] = useState(false);
  const handleShow = () => {
    dispatch(setShowOtpBlock(false));
    setShow(true);
  };
  const handleClose = () => {
    setShow(false);
  };

  // reload data when
  const [carData, setCarData] = useState([]);
  useEffect(() => {
    setCarData(data);
  }, [data]);

  // get special data according home,brand or category page when user logined
  const getSpecialDataForState = () => {
    if (whichPage == "home") {
      // home or dynamic page special data
      dispatch(
        getDynamicPageData(
          get_cookie("currentLocationId"),
          "home",
          1,
          get_cookie("token")
        )
      ).then((res) => {
        setCarData(res.special);
      });
    } else if (whichPage == "brand") {
      callVehicleApiForFilterOption();
    } else {
      callVehicleApiForFilterOption();
    }
  };

  /*******************
  @purpose : Save vehicle as favorite
  @Parameter : {}
  @Author : INIC
  ******************/
  const saveHandler = (id, slug) => {
    setVId(id);
    setVSlug(slug);
    setClickOnFavorite(1);
    if (user?.token) {
      favoriteApi(id);
    } else {
      //show login popup
      handleShow();
    }
  };

  /*******************
  @purpose : user token
  @Parameter : {}
  @Author : INIC
  ******************/
  useEffect(() => {
    if (user?.token && clickOnFavorite) {
      // call vehicle detail api
      dispatch(
        getVehicalDetailData(get_cookie("currentLocationId"), vSlug)
      ).then((res) => {
        setClickOnFavorite(0);
        if (res?.vehicle?.is_favourite) {
          setFavUnFavMessage(ALREADY_SAVED_WISHLIST);
          setAddOnClass("show");
          setTimeout(() => {
            setAddOnClass("hide");
          }, 1000);
          getSpecialDataForState();
        } else {
          favoriteApi(vId, true); // 1=> load data as per home,brand,category
        }
      });
    }
  }, [user?.token]);

  const favoriteApi = (id, loadData) => {
    let favorite = "";
    let fillId = "f_" + id;

    if (id) {
      favorite = { vehicle_id: id };
    } else {
      favorite = { vehicle_id: vId };
    }

    dispatch(addUserFavorite(favorite)).then((res) => {
      if (res.success) {
        if (res?.data?.is_favourite) {
          setFavUnFavMessage(SAVED_WISHLIST);
          setIsSaved(true);
          const element = document.getElementById(fillId);
          if (fillId && typeof element != "undefined" && element != null) {
            document
              .getElementById(fillId)
              .classList.remove("icon-empty-heart");
            document.getElementById(fillId).classList.add("icon-fill-heart");
          }
        } else {
          setFavUnFavMessage(REMOVED_WISHLIST);
          setIsSaved(false);
          const element = document.getElementById(fillId);
          if (fillId && typeof element != "undefined" && element != null) {
            document.getElementById(fillId).classList.remove("icon-fill-heart");
            document.getElementById(fillId).classList.add("icon-empty-heart");
          }
        }
        setAddOnClass("show");
        setTimeout(() => {
          setAddOnClass("hide");
        }, 1000);
        // load data after user login
        if (loadData) {
          getSpecialDataForState();
        }
      }
    });
  };

  /*******************
  @purpose : Render HTML/ React Components
  @Author : INIC
  ******************/
  return (
    <>
      <div className="row">
        {carData &&
          carData.map((row, index) => (
            <div className="col-md-6 mb-sm-15 mb-30" key={index}>
              <CarCard
                row={row}
                slugUrl={`${slugPrefix}/${row.brand_detail.slug}/${
                  row.category_detail?.slug
                }/${row.slug}/${row.slug_id}${
                  is_mobile_app === "yes"
                    ? myVehicleSlug +
                      row?.brand_detail?.title +
                      "&vehicle_title=" +
                      row?.name
                    : ""
                }`}
                flag={flag}
                saveHandler={saveHandler}
                onCardClick={onVehicleClick}
              />
            </div>
          ))}
      </div>

      {/* Login modal */}
      <LoginModal show={show} handleClose={handleClose} />

      {/* success popup for favouirty and unfavority */}
      <SuccessPopup
        addOnClass={addOnClass}
        message={favUnFavMessage}
        error={!isSaved}
      />
    </>
  );
}
export default TheSpecials;
